import { useMutation } from "react-query";
import { AxiosError } from "axios";
import { axiosDefaultApi } from "src/lib/axios";
import { MutationConfig, queryClient } from "src/lib/react-query";
import useNotification from "src/store/Notifications/useNotification";


const deleteSpeed = ({ speedId }: { speedId: number }): Promise<string> => {
  return axiosDefaultApi.delete(`/api/Speeds/DeleteSpeed/${speedId}`);
};

type QueryFnType = typeof deleteSpeed;

type UseDeleteSpeedOptions = {
  speedId: number;
  config?: MutationConfig<QueryFnType>;
};

export const useDeleteSpeed = ({ config }: UseDeleteSpeedOptions) => {
  const { addNotification, setIsNotificationVisible } = useNotification();
  return useMutation({
    onError: (error: AxiosError<any>) => {
      if (error.response && error.response.data && error.response.data.message) {
        const responseMessage = error.response?.data.message;
        console.log(responseMessage);
        addNotification(responseMessage.toString(), 500);
        setIsNotificationVisible(true);
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries(["getAllSpeeds"]);
      addNotification(`Η Περιοχή Διαγράφηκε.`, 200);
      setIsNotificationVisible(true);
    },
    ...config,
    mutationFn: deleteSpeed,
  });
};
